import { render, staticRenderFns } from "./channel.history.vue?vue&type=template&id=073f1b83&"
import script from "./channel.history.vue?vue&type=script&lang=js&"
export * from "./channel.history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports